import React from 'react';
import { useTranslation } from 'react-i18next';
import './Podcasts.css';

function Podcasts() {
  const { t } = useTranslation();

  const podcastCategories = [
    {
      icon: '🌊',
      title: 'Surfers',
      description: 'Conversations with wave riders and ocean lovers'
    },
    {
      icon: '🎨',
      title: 'Artists',
      description: 'Dialogues with creative visionaries and makers'
    },
    {
      icon: '🔬',
      title: 'Scientists',
      description: 'Insights from researchers and innovators'
    },
    {
      icon: '🏺',
      title: 'Archeologists',
      description: 'Stories from those who uncover the past'
    },
    {
      icon: '💭',
      title: 'Dreamers',
      description: 'Conversations with visionaries and philosophers'
    },
    {
      icon: '👶',
      title: 'Wise Children',
      description: 'Voices of the new generation'
    }
  ];

  return (
    <section className="podcasts" id="podcasts">
      <div className="container">
        <div className="section-header animate-fade-in-up">
          <h2>{t('podcasts.title')}</h2>
          <div className="podcast-description">
            <p>{t('podcasts.description')}</p>
          </div>
        </div>

        <div className="podcasts-content">
          <div className="conversation-visual animate-fade-in-up">
            <div className="conversation-bubble">
              <div className="conversation-icon">🎙️</div>
              <p>"The power of conversation to inspire, awaken, and connect"</p>
            </div>
            <div className="sound-waves">
              <span className="wave"></span>
              <span className="wave"></span>
              <span className="wave"></span>
              <span className="wave"></span>
              <span className="wave"></span>
            </div>
          </div>

          <div className="categories-grid">
            {podcastCategories.map((category, index) => (
              <div key={index} className="category-card animate-fade-in-up">
                <div className="category-icon">{category.icon}</div>
                <h3>{category.title}</h3>
                <p>{category.description}</p>
              </div>
            ))}
          </div>

          <div className="podcast-cta animate-fade-in-up">
            <div className="world-building-text">
              <p>"...and the wise children of this new world we are co-creating"</p>
            </div>
            <button className="btn btn-primary podcast-btn">
              {t('podcasts.explore')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Podcasts;